<template>
  <nav>
    <active-button
      :active="isActive('page', 'sports')"
      @click="$router.push('/prematch')"
    >
      {{ $t('menu.sports') }}
    </active-button>
    <active-button
      :active="isActive('page', 'live')"
      @click="$router.push('/live')"
    >
      {{ $t('menu.live') }}
    </active-button>
    <!--active-button
      :active="isActive('view', 'casino')"
      @click="$router.push('/games')"
    >
      {{ $t('common.games') }}
    </active-button-->
    <active-button
      class="favorites-button"
      :title="$t('menu.favorites')"
      :active="isActive('page', 'favorites')"
      @click="$router.push('/favorites/' + (isActive('page', 'sports') ? 'prematch' : 'live'))"
    >
      <i-favorites class="favorites-icon" v-if="!favoritesQ" :title="$t('menu.favorites')"></i-favorites>
      <i-favorites class="favorites-icon active" v-if="favoritesQ" :title="$t('menu.favorites')"></i-favorites>
      <span class="favorites-quantity" v-if="favoritesQ">{{ favoritesQ }}</span>
    </active-button>
    <results-menu />
    <!--active-button
      :active="isActive('page', 'resultslive')"
      @click="followResults"
    >
      {{ $t('menu.results') }}
    </active-button-->
    <!--results-menu /-->
    <!--active-button
      :active="isActive('page', 'payments')"
      @click="$router.push('/payments')"
    >
      {{ $t('menu.payments') }}
    </active-button-->
    <!--active-button
      :active="isActive('page', 'rules')"
      @click="$router.push('/rules')"
    >
      {{ $t('menu.rules') }}
    </active-button-->
    <active-button
      @click="openStatistics()"
    >
      <span v-if="this.$i18n.locale === 'ru'">Статистика</span>
      <span v-if="this.$i18n.locale === 'en'">Statistics</span>
      <span v-if="this.$i18n.locale === 'az'">Oyunların analizi</span>
    </active-button>
    <!--active-button
      @click="$router.push('/bonuses')"
    >
      {{ $t('account.bonus') }}
    </active-button-->
    <!--active-button
      @click="affiliates()"
      v-if="this.$i18n.locale !== 'az'"
    >
      Affiliates
    </active-button>
    <active-button
      @click="affiliates()"
      v-if="this.$i18n.locale === 'az'"
    >
      əməkdaşlıq
    </active-button>
    <active-button
      @click="affiliates()"
      v-if="this.$i18n.locale === 'az'"
    >
      əməkdaşlıq
    </active-button-->
    <!--active-button
      @click="openChat()"
    >
      <span style="margin-top: 3px;">
        <svg width="15" height="12" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 1C0 0.447715 0.447715 0 1 0H11C11.5523 0 12 0.447715 12 1V7C12 7.55228 11.5523 8 11 8C11 8 5 8 4 8C2.85832 8 1.49997 8.85465 0.696097 9.44658C0.418292 9.65114 0 9.45518 0 9.11019V1ZM2.5 2C2.22386 2 2 2.22386 2 2.5C2 2.77614 2.22386 3 2.5 3H9.5C9.77614 3 10 2.77614 10 2.5C10 2.22386 9.77614 2 9.5 2H2.5ZM2 4.5C2 4.22386 2.22386 4 2.5 4H6.5C6.77614 4 7 4.22386 7 4.5C7 4.77614 6.77614 5 6.5 5H2.5C2.22386 5 2 4.77614 2 4.5Z" fill="white"></path>
        </svg>
      </span>
      <span v-if="$i18n.locale === 'ru'">Чат</span>
      <span v-if="$i18n.locale === 'en'">Chat</span>
      <span v-if="$i18n.locale === 'az'">Canlı dəstək</span>
    </active-button-->
  </nav>
</template>

<script>
import IFavorites from 'vue-material-design-icons/Star'
import ActiveButton from '@/components/buttons/ActiveButton'
import ResultsMenu from '@/components/header/ResultsMenu'
import { mapState } from 'vuex'

export default {
  components: { IFavorites, ActiveButton, ResultsMenu },
  computed: {
    ...mapState({
      favoritesQ: state => state.favorites.quantity
    })
  },
  methods: {
    followResults () {
      // this.$router.push('/results/date/' + (new Date(Date.now() + 3600000 * 3)).toISOString().split('T')[0])
      this.$router.push('/resultslive')
    },
    affiliates () {
      window.location.assign('https://affiliates.betstil.com')
    },
    openChat () {
      window.location.assign('javascript:void(Tawk_API.toggle())')
    },
    openStatistics () {
      window.open('https://statistic.sportdemo.ru/statistics?lang=' + this.$i18n.locale, 'statistics', 'width=1000,height=700,menubar=no,toolbar=no,location=no')
    }
  }
}
</script>

<style scoped>
nav { display: flex; }
nav .active-button { color: #fff; font-size: 14px !important; height: 50px; line-height: 50px !important; padding: 0 10px; font-weight: bold !important; }
.favorites-button { align-items: center; display: flex; }
.favorites-quantity { margin-top: -23px; margin-left: -2px; color: #8ce95d; }
.favorites-icon { font-size: 24px; }
.favorites-icon.active { color: #8ce95d; }
</style>



// WEBPACK FOOTER //
// src/components/header/MainMenu.vue